import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { aggregateStorePerformanceRouter } from './routing/aggregateStorePerformanceRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { aggregateStorePerformanceAccessControl } from './access-control/aggregateStorePerformanceAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'aggregate-store-performance',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'aggregate-store-performance-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [aggregateStorePerformanceRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.OperationsLabor,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'View high-level store performance summaries across sales, labor, and operations',
          labelId: 'aggregateStorePerformanceDomain.title.new',
          route: 'aggregate-store-performance',
          accessControl: aggregateStorePerformanceAccessControl,
          position: 1,
          positionNavV2: 1,
          inToolPermissions: [],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
